import React from 'react';
import { Route, Navigate, Routes } from 'react-router-dom';

// internal
import { AuthState, provideAuth } from 'context/auth';
import { AlertsState, provideAlerts } from 'context/alerts';

import { Header, Footer } from 'components/layout';
import { ProtectedRoute, AlertBox } from 'components';
import WelcomePage from 'pages/welcome-page';
import ExamNotValidPage from 'pages/examnotvalid-page';
import VirtualMachinePage from 'pages/virtual-machine-page';
import SandboxPage from 'pages/sandbox-page';
import CustomStyles from 'styles/custom-styles';

interface Props {
  auth: AuthState;
  alerts: AlertsState;
}

const App = (props: Props) => {
  const imageWelcome = require(`images/${process.env.REACT_APP_BACKGROUND_IMAGE}`);
  return (
    <>
      <CustomStyles />
      <Header />
      <main id="main">
        <AlertBox
          alertType={props.alerts.type}
          floating={!props.alerts.staticAlert}
        >
          {props.alerts.message}
        </AlertBox>
        <Routes>
          <Route path="/" element={<WelcomePage />} />
          <Route path="/examnotvalid" element={<ExamNotValidPage />} />
          <Route
            path="/:sandboxId?"
            element={
              <ProtectedRoute
                component={SandboxPage}
                loaderBackground={imageWelcome}
              />
            }
          />
          <Route
            path="/:sandboxId/vm"
            element={
              <ProtectedRoute
                component={VirtualMachinePage}
                checkTerms
                loaderBackground={imageWelcome}
              />
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
};

export default provideAlerts(provideAuth(App));
